import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'
import { z } from 'zod'

export const Inv4210SearchParamsSchema = z
  .object({
    itemId: z.coerce.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    warehouse: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv4210SearchParams = z.infer<typeof Inv4210SearchParamsSchema>

//==============================================================

export const Inv4210SearchResultItemSchema = z.object({
  id: z.number(),
  date: z.coerce.date(),
  itemId: z.number(),
  partyId: z.number().nullable(),
  warehouse: z.string().optional(),
  remark: z.string(),
  refNo: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  debitQty: z.number(),
  creditQty: z.number(),
  unitPrice: z.number().nullable(),
  forwardBalance: z.number(),
})

export type Inv4210SearchResultItem = z.infer<
  typeof Inv4210SearchResultItemSchema
>

//==============================================================

export const Inv4210SearchResultSchema = z
  .object({
    data: z.array(Inv4210SearchResultItemSchema),
  })
  .merge(BasePaginateResultSchema)
export type Inv4210SearchResult = z.infer<typeof Inv4210SearchResultSchema>
